import { useState } from 'react'

export function useExpenseSelection() {
	const [selectedExpenses, setSelectedExpenses] = useState(new Set())

	const handleSelectAll = (checked, expensesData) => {
		if (checked) {
			setSelectedExpenses(new Set(expensesData.map(expense => expense._id)))
		} else {
			setSelectedExpenses(new Set())
		}
	}

	const handleSelectExpense = (expenseId, checked) => {
		const next = new Set(selectedExpenses)
		if (checked) {
			next.add(expenseId)
		} else {
			next.delete(expenseId)
		}
		setSelectedExpenses(next)
	}

	const clearSelection = () => setSelectedExpenses(new Set())

	const getSelectionState = expensesData => {
		const total = expensesData.length
		const selectedCount = selectedExpenses.size
		return {
			isAllSelected: total > 0 && selectedCount === total,
			isIndeterminate: selectedCount > 0 && selectedCount < total,
		}
	}

	return {
		selectedExpenses,
		handleSelectAll,
		handleSelectExpense,
		clearSelection,
		getSelectionState,
	}
}
